/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.ApiResponse,
  DeleteGroup: (params: vp.DeleteGroupRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostDeleteGroup: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldDeleteGroup, setShouldDeleteGroup] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.DeleteGroupRequest>({
    GroupID: '',
  });
  const [response, setResponse] = useState<vp.ApiResponse>({
    Success: false,
    ErrorMessage: '',
  });

  useEffect(() => {
    if (!shouldDeleteGroup) return () => {};

    const PostDeleteGroup = async () => {
      setDataFetchingInfo(true, 'deleting group', 'fullScreen');
      const res = await api.postDeleteGroup(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldDeleteGroup) void PostDeleteGroup();
    setShouldDeleteGroup(false);
    return () => {
      source.cancel();
    };
  }, [shouldDeleteGroup]);

  return [
    response,
    (_params: vp.DeleteGroupRequest) => {
      setParams(_params);
      setShouldDeleteGroup(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setShouldDeleteGroup(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostDeleteGroup);